// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
export const StoneImageFragmentDoc = gql`
    fragment StoneImage on GemsApi_StoneImage {
  __typename
  url
  isB2B
}
    `;